(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["price-otp-tooltip"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    var mq = window.matchMedia('(max-width: 749px)');
    var hoverTimeout;

    /*
     * Variant changes replace the price block's innerHTML.
     * Always retrieve the currently rendered elements.
     */
    function getLabel() {
      return document.querySelector('[data-id="ab-otp-label"]');
    }

    function getDesktopTooltip() {
      return document.querySelector(
        '[data-id="ab-otp-tooltip-desktop"]'
      );
    }

    /*
     * The mobile tooltip and backdrop are moved to body when opened,
     * so these elements must be searched for globally.
     */
    function getMobileTooltip() {
      return document.querySelector(
        '[data-id="ab-otp-tooltip-mobile"]'
      );
    }

    function getBackdrop() {
      return document.querySelector(
        '[data-id="ab-otp-backdrop"]'
      );
    }

    function isClickOnlyMode() {
      var label = getLabel();

      return !!(
        label &&
        label.getAttribute('data-click-only') === 'true'
      );
    }

    function getTrigger() {
      var label = getLabel();

      if (!label) return null;

      if (isClickOnlyMode()) {
        return label.querySelector('.price-otp-label__icon');
      }

      return label;
    }

    function setExpanded(isExpanded) {
      var trigger = getTrigger();

      if (!trigger) return;

      trigger.setAttribute(
        'aria-expanded',
        isExpanded ? 'true' : 'false'
      );
    }

    function isMobileOpen() {
      var mobileTooltip = getMobileTooltip();

      return !!(
        mobileTooltip &&
        mobileTooltip.classList.contains('is-active')
      );
    }

    function isDesktopOpen() {
      var desktopTooltip = getDesktopTooltip();

      return !!(
        desktopTooltip &&
        desktopTooltip.classList.contains('is-active')
      );
    }

    function openMobile() {
      var mobileTooltip = getMobileTooltip();
      var backdrop = getBackdrop();

      if (!mobileTooltip || !backdrop) return;

      /*
       * Remove orphaned elements left in body when the product variant
       * changed while the drawer was open.
       */
      document
        .querySelectorAll(
          'body > [data-id="ab-otp-tooltip-mobile"]'
        )
        .forEach(function (node) {
          if (node !== mobileTooltip) {
            node.remove();
          }
        });

      document
        .querySelectorAll(
          'body > [data-id="ab-otp-backdrop"]'
        )
        .forEach(function (node) {
          if (node !== backdrop) {
            node.remove();
          }
        });

      if (mobileTooltip.parentNode !== document.body) {
        document.body.appendChild(mobileTooltip);
      }

      if (backdrop.parentNode !== document.body) {
        document.body.appendChild(backdrop);
      }

      document.documentElement.classList.add('ios-stop-scroll');
      backdrop.classList.add('is-active');
      mobileTooltip.classList.add('is-active');

      setExpanded(true);
    }

    function closeMobile() {
      /*
       * Close every active instance because a previous product-variant
       * render may have left an old tooltip inside body.
       */
      document
        .querySelectorAll(
          '[data-id="ab-otp-tooltip-mobile"].is-active'
        )
        .forEach(function (node) {
          node.classList.remove('is-active');
        });

      document
        .querySelectorAll(
          '[data-id="ab-otp-backdrop"].is-active'
        )
        .forEach(function (node) {
          node.classList.remove('is-active');
        });

      document.documentElement.classList.remove(
        'ios-stop-scroll'
      );

      setExpanded(false);
    }

    function openDesktop() {
      var desktopTooltip = getDesktopTooltip();

      if (!desktopTooltip) return;

      desktopTooltip.classList.add('is-active');
      setExpanded(true);
    }

    function closeDesktop() {
      var desktopTooltip = getDesktopTooltip();

      if (desktopTooltip) {
        desktopTooltip.classList.remove('is-active');
      }

      setExpanded(false);
    }

    /*
     * Standard desktop hover behavior.
     *
     * This is completely disabled when the template suffix is
     * test-reorder.
     */
    document.addEventListener('mouseover', function (event) {
      if (mq.matches || isClickOnlyMode()) return;

      var label =
        event.target.closest &&
        event.target.closest(
          '[data-id="ab-otp-label"]'
        );

      if (!label) return;

      if (label.contains(event.relatedTarget)) return;

      clearTimeout(hoverTimeout);
      openDesktop();
    });

    document.addEventListener('mouseout', function (event) {
      if (mq.matches || isClickOnlyMode()) return;

      var label =
        event.target.closest &&
        event.target.closest(
          '[data-id="ab-otp-label"]'
        );

      if (!label) return;

      if (label.contains(event.relatedTarget)) return;

      hoverTimeout = setTimeout(function () {
        closeDesktop();
      }, 200);
    });

    /*
     * Click event delegation keeps the tooltip functional after
     * product-variant price-block re-renders.
     */
    document.addEventListener('click', function (event) {
      var target = event.target;

      if (!target.closest) return;

      /*
       * These close buttons are checked first because the desktop
       * tooltip is nested inside .price-otp-label__icon.
       */
      if (
        target.closest(
          '.price-otp-tooltip--desktop__close'
        )
      ) {
        event.preventDefault();
        event.stopPropagation();

        closeDesktop();
        return;
      }

      if (
        target.closest(
          '.price-otp-tooltip--mobile__close'
        )
      ) {
        event.preventDefault();
        event.stopPropagation();

        closeMobile();
        return;
      }

      /*
       * TEST-REORDER CLICK-ONLY MODE
       *
       * Only the tooltip icon opens the desktop or mobile tooltip.
       * On desktop, clicking the icon again toggles the tooltip closed.
       * On mobile, nothing except the tooltip close button can close it.
       */
      if (isClickOnlyMode()) {
        var icon = target.closest(
          '.price-otp-label--click-only .price-otp-label__icon'
        );

        var clickedDesktopTooltip = target.closest(
          '[data-id="ab-otp-tooltip-desktop"]'
        );

        /*
         * Do not treat clicks inside the desktop tooltip content as
         * new icon-trigger clicks.
         */
        if (icon && !clickedDesktopTooltip) {
          event.preventDefault();
          event.stopPropagation();

          if (mq.matches) {
            if (!isMobileOpen()) {
              openMobile();
            }
          } else if (isDesktopOpen()) {
            closeDesktop();
          } else {
            openDesktop();
          }
        }

        /*
         * Returning here disables:
         * - Backdrop closing
         * - Outside-click closing
         * - Label-text clicking
         * - Mobile icon toggle closing
         */
        return;
      }

      /*
       * Standard behavior for all other product templates.
       */
      if (
        target.closest(
          '[data-id="ab-otp-backdrop"]'
        )
      ) {
        event.preventDefault();
        event.stopPropagation();

        closeMobile();
        return;
      }

      var label = target.closest(
        '[data-id="ab-otp-label"]'
      );

      if (label && mq.matches) {
        event.preventDefault();

        if (isMobileOpen()) {
          closeMobile();
        } else {
          openMobile();
        }

        return;
      }

      /*
       * Standard outside-click closing for non-test templates.
       */
      var desktopTooltip = getDesktopTooltip();
      var mobileTooltip = getMobileTooltip();
      var backdrop = getBackdrop();

      if (
        isDesktopOpen() &&
        desktopTooltip &&
        !desktopTooltip.contains(target) &&
        !label
      ) {
        closeDesktop();
      }

      if (
        isMobileOpen() &&
        mobileTooltip &&
        !mobileTooltip.contains(target) &&
        !label &&
        !(
          backdrop &&
          backdrop.contains(target)
        )
      ) {
        closeMobile();
      }
    });

    /*
     * Keyboard support for the icon on test-reorder.
     *
     * Enter and Space open the desktop tooltip and toggle it closed
     * on a repeat press. On mobile, they only open — the tooltip
     * closes only via its close button.
     */
    document.addEventListener('keydown', function (event) {
      if (!isClickOnlyMode()) return;

      if (
        event.key !== 'Enter' &&
        event.key !== ' '
      ) {
        return;
      }

      var target = event.target;

      if (!target.closest) return;

      var icon = target.closest(
        '.price-otp-label--click-only .price-otp-label__icon'
      );

      var clickedDesktopTooltip = target.closest(
        '[data-id="ab-otp-tooltip-desktop"]'
      );

      if (!icon || clickedDesktopTooltip) return;

      event.preventDefault();

      if (mq.matches) {
        if (!isMobileOpen()) {
          openMobile();
        }
      } else if (isDesktopOpen()) {
        closeDesktop();
      } else {
        openDesktop();
      }
    });
  });
  } catch(e) { console.error(e); }
})();

})();
